// extracted by mini-css-extract-plugin
module.exports = {"item":"SideDrawerItem-module--item--3HjFZ","itemLabel":"SideDrawerItem-module--itemLabel--yBzLp","itemLabelActive":"SideDrawerItem-module--itemLabelActive--3oryA"};